import React, { useState } from 'react';
import { FormInput } from '../../common/FormInput';
import { Button } from '../../common/Button';
import coachProfileService from '../../../services/coachProfileService';

export const PasswordSetModal = ({ isOpen, onClose, onSubmit, resetToken }) => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handlePasswordChange = (e) => setPassword(e.target.value);
  const handleConfirmChange = (e) => setConfirm(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password && confirm && password === confirm) {
      setLoading(true);

      try {
        await coachProfileService.resetPassword(resetToken, password, confirm);
        setLoading(false);
        setSuccess(true);

        setTimeout(() => {
          setSuccess(false);
          setPassword('');
          setConfirm('');
          if (onSubmit) onSubmit();
          if (onClose) onClose();
        }, 1500);
      } catch (err) {
        setLoading(false);
        setError(err.response?.data?.message || 'Failed to reset password. Please try again.');
      }
    }
  };

  const handleClose = () => {
    setPassword('');
    setConfirm('');
    setSuccess(false);
    setError('');
    onClose && onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/60 z-50">
      <div className="bg-jp-card border border-jp-outline/70 rounded-2xl p-8 shadow-xl w-full max-w-xl mx-auto relative">
        {/* Close button */}
        <button
          className="absolute top-6 right-6 text-jp-muted hover:text-jp-ink text-2xl"
          onClick={handleClose}
          aria-label="Close"
        >
          &times;
        </button>
        <h2 className="text-jp-ink text-2xl font-bold mb-10 text-center">PASSWORD RESET</h2>

        {/* Error Message */}
        {error && (
          <div className="mb-4 p-3 bg-red-500/20 border border-red-500/50 rounded-lg text-red-200 text-sm text-center">
            {error}
          </div>
        )}

        <form className="flex flex-col gap-8" onSubmit={handleSubmit}>
          <FormInput
            label="Password"
            name="password"
            type="password"
            value={password}
            onChange={handlePasswordChange}
            required
            placeholder="Enter password"
          />
          <FormInput
            label="Confirm password"
            name="confirm"
            type="password"
            value={confirm}
            onChange={handleConfirmChange}
            required
            placeholder="Re-enter password"
          />
          <Button
            type="submit"
            disabled={!password || !confirm || password !== confirm || loading}
            loading={loading}
            fullWidth={false}
            className="mt-4 mx-auto"
          >
            {loading ? "Saving..." : "SAVE CHANGES"}
            {(password && confirm && password === confirm && !loading) && (
              <span className="ml-3 rounded-full bg-white/20 border border-white/60 flex items-center justify-center w-8 h-8">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <path d="M5 13l4 4L19 7" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            )}
          </Button>
          {/* Success tick after submit */}
          {success && (
            <div className="text-green-600 dark:text-green-300 text-lg font-semibold text-center">Password reset successful!</div>
          )}
        </form>
      </div>
    </div>
  );
};
